<template>
    <div>
      <div style="text-align: center">
        <h3>Tambah Device</h3>
      </div>
      <br />
      <form v-on:submit.prevent="addDevice">
        <label>Nama Device</label>
        <input type="text" class="form-control" v-model="form.name" autofocus required />
        <br />
        <label>Nomor HP</label>
        <input type="number" class="form-control" v-model="form.number" autofocus required />
        <br />
        <label>Metode Koneksi</label>
        <div class="form-group">
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="pairQr" class="custom-control-input" value="qr" v-model="form.pair_method">
                <label class="custom-control-label" for="pairQr">QR Code</label>
            </div>
            <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" id="pairPhone" class="custom-control-input" value="phone" v-model="form.pair_method">
                <label class="custom-control-label" for="pairPhone">Nomor Telepon</label>
            </div>
        </div>
        <br />

        <div class="button-group d-flex pt-25">
          <br>
            <button type="submit" class="btn btn-primary btn-block btn-default btn-squared text-capitalize mx-auto d-block">
              Tambah
            </button>
        </div>
      </form>
    </div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        form: {
          name: "",
          number: "",
          pair_method: "qr",
          multidevice: "1",
          type: "unofficial"
        },
      };
    },
    mounted() {
  
    },
    methods: {
      async addDevice(){
        try{
          let request = this.form
          let response = await this.$store.dispatch('device_create', request)
          
          this.$toast.success(response.data.message);
          this.$root.$emit("toggle_modal", "new_device")
          this.$root.$emit("refresh_table", true)
          if (request.pair_method === 'phone') {
            this.$router.push('/device/scan?id=' + response.data.data?.id + '&mode=phone')
          }
        }catch(err){
          this.$toast.error(err.response.data.message);
        }
      },
    },
  };
  </script>
  
